/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { gql, useQuery } from '@apollo/client';
import { useTokenContext } from "@exo/frontend-common-app-identity-and-access";


export const useSubscriptionPreference = () => {
  const tokenContext = useTokenContext();
  const FETCH_SUBSCRIPTIONPREFERENCE_GQL = gql`
    query FetchSubs {
	    fetchSubscriptions {
        subscribeNews
	    }
    }`

  const { data, loading, error,  } = useQuery(FETCH_SUBSCRIPTIONPREFERENCE_GQL, {
    fetchPolicy: "network-only",
    skip: !tokenContext.getToken(),
    context:{clientName:"notification"}
  });

  return { data, loading, error };
}